<template>
  <v-data-table
    :headers="headers"
    :loading="loading"
    :items="settings"
    :search="search"
    sort-by="id"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>AJUSTES DO ESTOQUE</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Busca"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <!-- <v-btn color="blue darken-1" dark to="/express/ajustes/novo">
          <v-icon>mdi-plus</v-icon>
          Novo
        </v-btn> -->
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-toolbar color="red lighten-1" dark class="text-h5"
              >Atenção</v-toolbar
            >
            <v-card-title class="text-h6">
              Tem certeza que deseja Deletar?
            </v-card-title>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete"
                >Fechar</v-btn
              >
              <v-btn color="red darken-1" dark @click="deleteItemConfirm">
                <v-icon dark>mdi-delete</v-icon>
                Deletar
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.type="{ item }">
      {{ item.type === "S" ? "Saída" : "Entrada" }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.estimate="{ item }">
      {{ item.estimate ? "Sim" : "Não" }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.price="{ item }">
      {{ item.price ? "Sim" : "Não" }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.info="{ item }">
      {{ item.info ? "Sim" : "Não" }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.grid="{ item }">
      {{ item.grid ? "Sim" : "Não" }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.status="{ item }">
      <v-chip :color="getColor(item.status)" dark>
        {{ getLabel(item.status) }}
      </v-chip>
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.actions="{ item }">
      <v-tooltip top color="blue darken-1">
        <!-- eslint-disable-next-line -->
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            class="mr-2"
            color="blue darken-1"
            @click="editItem(item)"
            v-bind="attrs"
            v-on="on"
          >
            mdi-pencil
          </v-icon>
        </template>
        <span>Editar</span>
      </v-tooltip>
      <v-tooltip top color="error">
        <!-- eslint-disable-next-line -->
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            color="red darken-1"
            @click="deleteItem(item)"
            v-bind="attrs"
            v-on="on"
          >
            mdi-delete
          </v-icon>
        </template>
        <span>Deletar</span>
      </v-tooltip>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize"> Recarregar </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { settings as settingsStock } from "@/helpers/settings_express_stock";

export default {
  data: () => ({
    dialogDelete: false,
    search: "",
    loading: false,
    headers: [
      {
        text: "ID",
        align: "right",
        value: "id",
        width: 50,
      },
      { text: "Descrição", value: "name", width: 350 },
      { text: "Tipo", value: "type", width: 100 },
      // { text: "Info Docto", value: "type", width: 100 },
      { text: "Preço Item", value: "price", width: 100 },
      { text: "Estimativa", value: "estimate", width: 100 },
      { text: "Grade Aberta", value: "grid", width: 100 },
      // {
      //   text: "Ação",
      //   value: "actions",
      //   sortable: false,
      //   width: 100,
      //   align: "right",
      // },
    ],
    settings: [
      // {
      //   id: 1,
      //   name: "ESTOQUE INICIAL (GRADE PADRÃO)",
      //   type: "E",
      //   info: false,
      //   price: false,
      //   estimate: true,
      //   grid: false,
      // },
      // {
      //   id: 3,
      //   name: "ENTRADA (GRADE ABERTA)",
      //   type: "E",
      //   info: false,
      //   price: false,
      //   estimate: false,
      //   grid: true,
      // },
      // {
      //   id: 4,
      //   name: "SAÍDA (GRADE ABERTA)",
      //   type: "S",
      //   info: false,
      //   price: false,
      //   estimate: false,
      //   grid: true,
      // },
      // {
      //   id: 5,
      //   name: "ENTRADA (GRADE FECHADA)",
      //   type: "E",
      //   info: false,
      //   price: false,
      //   estimate: false,
      //   grid: false,
      // },
      // {
      //   id: 6,
      //   name: "SAÍDA (GRADE FECHADA)",
      //   type: "S",
      //   info: false,
      //   price: false,
      //   estimate: false,
      //   grid: false,
      // },
      // {
      //   id: 7,
      //   name: "ESTOQUE INICIAL (GRADE ABERTA)",
      //   type: "E",
      //   info: false,
      //   price: false,
      //   estimate: true,
      //   grid: true,
      // },
    ],
    editedItem: {
      name: "",
      status: 1,
    },
    defaultItem: {
      name: "",
      status: 1,
    },
  }),

  computed: {},

  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.settings = settingsStock;
    this.initialize();
  },

  methods: {
    async initialize() {},
    getColor(status) {
      return status == 1 ? "green" : "red";
    },
    getLabel(status) {
      return status == 1 ? "Ativo" : "Desativado";
    },

    async getCests() {},
    editItem(item) {
      this.$router.push({
        name: "SettingsOrderEditExpress",
        params: { id: item.id },
      });
    },
    deleteItem(item) {
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {},

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },
    handleClickRow(event, item) {
      this.editItem(item.item);
    },
  },
};
</script>
